import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MeasurementsReducer } from 'types/mainPage';

const initialMode = {
  ruler: false,
};

const initialState: MeasurementsReducer = {
  mode: initialMode,
};

export const measurementsSlice = createSlice({
  initialState,
  name: 'measurements',
  reducers: {
    toggleRulerMode(state) {
      state.mode.ruler = !state.mode.ruler;
    },

    resetMeasurements() {
      return initialState;
    },
  },
});

export default measurementsSlice.reducer;
